import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKPRODUCTDETAILSBLOCK_LEGACY_FIELD_ORDER = [
  "primary_button_background_color",
  "primary_button_text_color",
  { type: 'separator' },
  "background_color",
  "text_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskProductDetailsBlockDescriptor: _generatedKioskProductDetailsBlockDescriptor,
  kioskProductDetailsBlockBlocDefinition,
  kioskProductDetailsBlockDashboardLayout,
  kioskProductDetailsBlockConfig,
  kioskProductDetailsBlockResolveConfig,
  kioskProductDetailsBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Product - Details",
    componentType: 'KioskProductDetailsBlockComponent',
    category: 'kiosk',
    description: "Kiosk Product - Details.",
    keywords: [],
    allowedIn: [
      { bloc: 'KioskLightProductDetailsPageComponent', slot: 'body' },
    ],


    sharedFields: {}
  },

  () => ({
    primary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-product-details.primary-button-background-color.label",
      }
    }),
    primary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-product-details.primary-button-text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-product-details.background-color.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#000"},
      options: {
        label: "pages.blocks.kiosk-product-details.text-color.label",
      }
    }),
    display_description: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.kiosk-product-details.display-description.label",
      }
    }),
    display_allergens: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.kiosk-product-details.display-allergens.label",
      }
    })
  }),

  () => ({
    omitFields: ["display_description", "display_allergens"] as const,
    tabs: [
      {
        label: "pages.blocks.kiosk-product-details.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-product-details.fieldset.page.label",
            fields: ["background_color", "text_color"],
          },
          {
            legend: "pages.blocks.kiosk-product-details.fieldset.button.label",
            fields: ["primary_button_background_color", "primary_button_text_color"],
          },
        ],
      },
    ],
  })
);

export function kioskProductDetailsBlockDescriptor(): IBlockDescriptor;
export function kioskProductDetailsBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskProductDetailsBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskProductDetailsBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskProductDetailsBlockDescriptor, kioskProductDetailsBlockProperties, fieldOrder);
}

export {
  kioskProductDetailsBlockBlocDefinition,
  kioskProductDetailsBlockDashboardLayout,
  kioskProductDetailsBlockProperties,
  kioskProductDetailsBlockConfig,
  kioskProductDetailsBlockResolveConfig,
};

export type KioskProductDetailsBlockConfig = typeof kioskProductDetailsBlockConfig;
